import './store';

import './style.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import withInput from './hoc/withInput';
import Base from './components/inputs/Base';
import Header from './components/Header';
import Panel from "./components/Panel";

const viewDom = document.getElementById( 'settings-view' );

ReactDOM.render(
	<Header />,
	viewDom.querySelector('.options-kit-header')
);
ReactDOM.render(
	<Panel />,
	viewDom.querySelector('.kf-options')
);

if ( window.wp.okt === undefined ) {
	window.wp.okt = {};
}
window.wp.okt.withInput = withInput;
window.wp.okt.Base = Base;
